import React from 'react';
import { PAGES } from '../../site/routes';
import usePrices from '../../hooks/usePrices';
import { FAQ, faqJsonLd } from '../../site/content';
import { usePageSeo, Breadcrumbs, PageHeader, Section, FaqList, LinkCards, CtaBand } from '../../site/ui';

const BREADCRUMBS = [
  { label: 'Accueil', to: PAGES.home },
  { label: 'FAQ', to: PAGES.faq },
];

export default function FaqPage() {
  const { servers } = usePrices();
  // La liste des serveurs vient du catalogue en ligne (mise à jour via l'admin)
  const items = FAQ.map(item => item.q.startsWith('Quels serveurs')
    ? { ...item, a: `Les ${servers.length} serveurs officiels : ${servers.map(s => s.name).join(', ')}.` }
    : item);

  usePageSeo({
    title: 'FAQ achat et vente de Kamas au Maroc | AV Kamas',
    description: "Réponses sur l'achat et la vente de Kamas au Maroc : paiement en DH, serveurs acceptés, délais, compte, prix par million et comparaison avec TryAndJudge.",
    path: PAGES.faq,
    breadcrumbs: BREADCRUMBS,
    jsonLd: [faqJsonLd(items)],
  });

  return (
    <main className="bg-gray-950 text-white">
      <Breadcrumbs items={BREADCRUMBS} />
      <PageHeader
        kicker="Aide"
        title={<>Questions fréquentes sur l'achat et la vente de <span className="text-yellow-400">Kamas</span></>}
      />
      <Section className="pt-0 md:pt-0">
        <FaqList items={items} />
      </Section>
      <Section title="Vous n'avez pas trouvé votre réponse ?" className="bg-gray-900/40">
        <LinkCards
          links={[
            { to: PAGES.buyGuide, title: 'Guide achat Kamas Maroc', text: 'Toutes les étapes pour acheter vos Kamas en dirhams.' },
            { to: PAGES.sellGuide, title: 'Guide vente Kamas Maroc', text: 'Toutes les étapes pour vendre vos Kamas contre des DH.' },
            { to: PAGES.dofusMaroc, title: 'Dofus Maroc', text: 'Paiement local et support dédié aux joueurs marocains.' },
          ]}
        />
      </Section>
      <CtaBand />
    </main>
  );
}
